



































































































































import { Component, Prop, Mixins } from 'vue-property-decorator';
import MixinChartRaw from '@/plugins/podolib/services/helper/mixins/chart/raw/index';

@Component
export default class ChartRawPhaseWalkSteps extends Mixins(MixinChartRaw) {
  getData(side: string, data: string) {
    let value = this.values.computed_data[side].aggregates[data].avg.toFixed(1);
    return parseFloat(value);
  }
  get stanceTime() {
    let left =
      (this.values.computed_data.left.aggregates.stance_time.avg /
        (this.values.computed_data.left.aggregates.stance_time.avg +
          this.values.computed_data.left.aggregates.swing_time.avg)) *
      100;
    let right =
      (this.values.computed_data.right.aggregates.stance_time.avg /
        (this.values.computed_data.right.aggregates.stance_time.avg +
          this.values.computed_data.right.aggregates.swing_time.avg)) *
      100;

    left = parseFloat(left.toFixed(1));
    right = parseFloat(right.toFixed(1));

    return { left, right };
  }
  get swingTime() {
    let left =
      (this.values.computed_data.left.aggregates.swing_time.avg /
        (this.values.computed_data.left.aggregates.stance_time.avg +
          this.values.computed_data.left.aggregates.swing_time.avg)) *
      100;
    let right =
      (this.values.computed_data.right.aggregates.swing_time.avg /
        (this.values.computed_data.right.aggregates.stance_time.avg +
          this.values.computed_data.right.aggregates.swing_time.avg)) *
      100;

    left = parseFloat(left.toFixed(1));
    right = parseFloat(right.toFixed(1));

    return { left, right };
  }
  get doubleContact() {
    let stance_time = (this.stanceTime.left + this.stanceTime.right) / 2;
    let swing_time = (this.swingTime.left + this.swingTime.right) / 2;
    return ((stance_time - swing_time) / 2).toFixed(0);
  }
}
